<template>
  <div class="project-view-track-list-item" :style="style">
    <div class="track-name">{{ track.name }}</div>
    <div class="track-hash">{{ track.filehash }}</div>
    <div class="track-tag"><tag-picker :tag="tag" @pick="onPickTag" /></div>
    <div class="track-del">
      <a href="#" @click.prevent.stop="$emit('delete', track)">
        <trash-icon />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { Tag, Track } from "@/models";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import { TrashIcon } from "@heroicons/vue/24/outline";
import TagPicker from "./TagPicker.vue";

@Options({
  components: {
    TrashIcon,
    TagPicker,
  },
  props: {
    track: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("projects", ["tags"]),
  },
})
export default class TrackListItem extends Vue {
  track!: Track;
  tags!: Record<string, Tag>;

  get style() {
    const backgroundColor = this.tag ? `#${this.tag.color}70` : "#ffffff70";
    return {
      backgroundColor,
    };
  }

  get tag() {
    return this.tags[this.track.tag_id];
  }

  onPickTag(tag: Tag) {
    this.$store.dispatch("projects/updateTrackTag", {
      filehash: this.track.filehash,
      tagId: tag._id,
    });
  }
}
</script>

<style lang="scss">
.project-view-track-list-item {
  padding: 4px;
  margin-bottom: 4px;
  height: 46px;
  box-sizing: border-box;
  display: grid;
  grid-template-areas:
    "name tag delete"
    "hash tag delete";
  grid-template-rows: 18px 12px;
  grid-template-columns: 390px auto 20px;
  grid-gap: 4px;
  .track-name {
    grid-area: name;
    font-weight: bold;
    font-size: 1.2em;
  }
  .track-hash {
    grid-area: hash;
    font-family: "Ubuntu Mono", "Courier New", Courier, monospace;
  }
  .track-tag {
    grid-area: tag;
  }
  .track-del {
    grid-area: delete;
    a {
      display: block;
      width: 20px;
      height: 20px;
      color: black;
    }
  }
}
</style>
